import { TenantSelect } from "../TenantSelect";
import logo from "./../../assets/Logo_Positiva 2.svg";
import menuMobile from "./../../assets/menu.svg";
import { Profile } from "../Profile";
import styles from "./styles.module.scss";

interface HeaderProps {
  setToggleMenuMobile: (value: boolean) => void;
  toggledMenuMobile: boolean;
}

export function Header({
  setToggleMenuMobile,
  toggledMenuMobile,
}: HeaderProps) {
  return (
    <>
      <header className={`${styles.header} no-print`}>
        <div className={styles.logoAndMenuHamburger}>
          <div className={styles.logo}>
            <img src={logo} alt="" />
          </div>

          <button
            className={styles.btnMenuMobile}
            onClick={() => setToggleMenuMobile(!toggledMenuMobile)}
          >
            <img src={menuMobile} alt="" />
          </button>
        </div>

        <div className={styles.actions}>
          <div className={styles.btnsAndProfile}>
            <div className={styles.tenantSelect}>
              <TenantSelect />
            </div>

            <div className={styles.profileDivider}>
              <div className={styles.divider}></div>
              <Profile />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
